import PageHeader from "@otel-lisanslama/components/PageHeader";
import React from "react";
import { Col, Container, Row, ListGroup, ListGroupItem } from "reactstrap";

type Tariff = {
  year: string;
  file: string;
  label?: string;
};

const TARIFFS: Tariff[] = [
  { year: "2026", file: "/assets/docs/MSF_ve_MUZFED_TARIFE_2026.docx" },
  { year: "2025", file: "/assets/docs/MSF_ve_MUZFED_TARIFE_2025.docx" },
  { year: "2024", file: "/assets/docs/MSF_ve_MUZFED_TARIFE_2024.pdf" },
  { year: "2023", file: "/assets/docs/MSF_ve_MUZFED_TARIFE.pdf" },
];

const Tariffs: React.FC = () => {
  return (
    <>
      <PageHeader title="Tarifeler" />
      <section className="section">
        <Container>
          <Row>
            <Col md={12}>
              <ListGroup flush>
                {TARIFFS.map((t) => (
                  <ListGroupItem key={t.year} className="py-3">
                    <h5 className="mb-2">{t.year} Tarifesi</h5>
                    <a
                      className="text-primary"
                      href={process.env.PUBLIC_URL + t.file}
                      target="_blank"
                      rel="noopener noreferrer"
                      download
                      aria-label={`${t.year} Müzik Federasyonları Tarifesini indir`}
                    >
                      {t.label ||
                        `${t.year} Müzik Federasyonları Tarifesini İndirmek İçin Tıklayınız`}
                    </a>
                  </ListGroupItem>
                ))}
              </ListGroup>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Tariffs;
